import React from "react";
import styles from "./MapBlock.module.scss";
import ConsentAwareEmbed from "@/components/ConsentAwareEmbed/ConsentAwareEmbed";

const MapBlock: React.FC = () => {
  return (
    <div className="container sideP88 mb60">
      <div className={styles.mapBlock}>
        <div className={styles.contactInfo}>
          <div className={styles.infoBlock}>
            <p className={styles.label}>Telefon</p>
            <a className={styles.phone} href="tel:+493052015191">
              +49 30 520 151 91
            </a>
          </div>
          <hr></hr>
          <div className={styles.infoBlock}>
            <p className={styles.label}>E-Mail</p>
            <a href="mailto:kunden@hixa.eu">
              <span className={styles.value}>kunden@hixa.eu</span>
            </a>
          </div>
          <hr></hr>
          <div className={styles.infoBlock}>
            <p className={styles.label}>Büro</p>
            <span className={styles.value}>
              Neukirchstraße 74, 13089 Berlin
            </span>
          </div>
        </div>

        <div className={styles.mapContainer}>
          <ConsentAwareEmbed type="google-maps">
            <iframe
              src="https://maps.google.com/maps?q=Neukirchstra%C3%9Fe+74%2C+13089+Berlin&t=ROADMAP&z=12&output=embed&iwloc=near"
              width="100%"
              height="520px"
              style={{ border: "0" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Neukirchstraße 74, 13089 Berlin"
            ></iframe>
          </ConsentAwareEmbed>
        </div>
      </div>
    </div>
  );
};

export default MapBlock;
